import Phaser from "phaser";
import { TILE_SIZE } from "../models/common";

/**
 * Creates ambient firefly particle effects spread across the map.
 * Returns the emitter so the caller can destroy it on shutdown.
 */
export function createFireflyEffect(
  scene: Phaser.Scene,
  mapTilesWide: number,
  mapTilesHigh: number
): Phaser.GameObjects.Particles.ParticleEmitter {
  if (!scene.textures.exists("firefly-particle")) {
    const gfx = scene.make.graphics({ add: false });
    gfx.fillStyle(0xffffff, 0.2);
    gfx.fillCircle(8, 8, 8);
    gfx.fillStyle(0xffffff, 0.55);
    gfx.fillCircle(8, 8, 5);
    gfx.fillStyle(0xffffff, 1.0);
    gfx.fillCircle(8, 8, 3);
    gfx.generateTexture("firefly-particle", 16, 16);
    gfx.destroy();
  }

  const mapWidth = mapTilesWide * TILE_SIZE;
  const mapHeight = mapTilesHigh * TILE_SIZE;

  const emitter = scene.add.particles(0, 0, "firefly-particle", {
    x: { min: 0, max: mapWidth },
    y: { min: 0, max: mapHeight },
    lifespan: { min: 3000, max: 8000 },
    speedX: { min: -12, max: 12 },
    speedY: { min: -15, max: 15 },
    scale: { min: 0.1, max: 0.4 },
    alpha: {
      onUpdate: (_p: any, _k: string, t: number) => Math.sin(t * Math.PI),
    },
    tint: [0xffffff],
    quantity: 2,
    frequency: 60,
    gravityY: 0,
    blendMode: Phaser.BlendModes.ADD,
  });

  emitter.setDepth(3000);

  // Exclude from all non-main cameras (e.g. UI camera)
  scene.cameras.cameras.forEach((camera: Phaser.Cameras.Scene2D.Camera) => {
    if (camera !== scene.cameras.main) {
      camera.ignore(emitter);
    }
  });

  return emitter;
}
